import axios from "axios";
import moment from "moment";
import jwt from "jsonwebtoken";

const getRefrenceDataList = async (
  refKey,
  setData,
  setSearchAPi,
  setLoading,

  setFormState
) => {
  const data = {
    refKey,
  };
  setLoading(true);
   

  await axios({
    method: "get", //you can set what request you want to be
    // url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
    url:`${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatListAll_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
     
     
      setData(res.data);
      setSearchAPi(res.data);
      setLoading(false);
    })
    .catch((err) => {});
};
const getRefrenceDataListForOneRecord = async (
  refKey,
  setData,
  setSearchAPi,
  setLoading,
  updateId,
  togglebutton,
  getdataFromID,
  setFormState,
  setChecked,
  setEmployeeRecorde,
  setReferenceTextlist,

  
) => {
  const data = {
    refKey,
  };
  setLoading(true);
  
  
  
  await axios({
    method: "get", //you can set what request you want to be
    // url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
    url:`${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatListAll_v1`,

    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
   

    if (refKey === "Treasury" ){
        if (getdataFromID) {
          const update = res.data.filter(
            (value) => getdataFromID === value.referenceId
          );
          
  
          setFormState((formState) => ({
            ...formState,
            referenceId: update[0]?.referenceId,
            referenceKey: update[0]?.referenceKey,
            referenceCode: update[0]?.referenceCode,
            referenceText: update[0]?.referenceText,
            referenceProp1: update[0]?.referenceProp1,
            referenceProp2: update[0]?.referenceProp2,
            referenceProp3: update[0]?.referenceProp3,
            referenceProp4: update[0]?.referenceProp4 || "",
            isActive: update[0]?.isActive ? true : false,
          }));
          getOneEmployee(update[0]?.referenceCode, setEmployeeRecorde)
          setChecked(update[0]?.referenceProp2 === "true" ? true:false)

          
        } else if (togglebutton) {
          
          const toggle = res.data.filter(
            (value) => togglebutton === value.referenceId
          );
          
  
          setFormState((formState) => ({
            ...formState,
            referenceId: toggle[0]?.referenceId,
            referenceKey: toggle[0]?.referenceKey,
            referenceCode: toggle[0]?.referenceCode||"",
            referenceText: toggle[0]?.referenceText||"",
            referenceProp1: toggle[0]?.referenceProp1||"",
            referenceProp2: toggle[0]?.referenceProp2||"",
            referenceProp3: toggle[0]?.referenceProp3 ||"",
            referenceProp4: toggle[0]?.referenceProp4 || "",
            isActive: toggle[0]?.isActive ? false : true,
          }));
        }

      }
      setData(res.data);
      setSearchAPi(res.data);
      setLoading(false);
    })
    .catch((err) => {});
};
const AddRefrenceDataList = async (
  formState,
  setFormState,
  setLoader,
  setSuccessMessage,
  setErrorMessage,
  setGetData,
  handleClose
) => {
  const dataStringyfy = JSON.stringify(formState);
  const dataParse = JSON.parse(dataStringyfy);

  
  setLoader(true);

  await axios({
    method: "post", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PostRefrenceDatList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: dataParse,
  })
    .then(async (res) => {
      
      handleClose();
      setSuccessMessage("Your Response has been Successfully Created");
      setLoader(false);
      getRefrenceDataList( formState.referenceKey,setGetData,()=>{}, setLoader,()=>{});


    })
    .catch((err) => {
      setErrorMessage(err.data);
      setLoader(false);
    });
};
const PutRefrenceDataList = async (
  formState,
  setFormState,
  setSuccessMessage,
  setErrorMessage,
  setLoader,
  setGetData,
  handleClose,
  setSearchAPi,


) => {
setLoader(true)
  const dataStringyfy = JSON.stringify(formState);
  const dataParse = JSON.parse(dataStringyfy);
  

  await axios({
    method: "put", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/PutRefrenceDatList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    data: dataParse,
  })
    .then(async (res) => {
      

      //    handleClose();

      getRefrenceDataList(formState.referenceKey,setGetData,setSearchAPi, setLoader,()=>{});
      setSuccessMessage("Your Response has been Successfully Updated");


     setLoader(false);

      handleClose();


      //    clearState(setFormState);
    })
    .catch((err) => {
      setErrorMessage(err.data);
      
      handleClose();

      setLoader(false);
    });
};

export const uptodate = (setLoader)=>{
  setLoader(true)
   
}
const deleteItem = async (
  formState,
  setFormState,
  deleteId,
  setLoader,
  setSuccessMessage,
  setErrorMessage,
  setGetData,
  handleClose

) => {
  // const dataStringyfy = JSON.stringify(formState);
  // const dataParse = JSON.parse(dataStringyfy);
  // 
  const data ={
    id:deleteId
  }
  setLoader(true);

  await axios({
    method: "delete", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/RemoveRefrenceDatList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",

    },
    params: data,
  })
    .then(async (res) => {
      

      //    handleClose();
      getRefrenceDataList(formState.referenceKey,setGetData,()=>{},setLoader,()=>{});
      setSuccessMessage("Your Response has been Successfully Deleted");



      setLoader(false);
    handleClose();


      //    clearState(setFormState);
    })
    .catch((err) => {
      setErrorMessage(err.data);
      setLoader(false);
    });
};
const getEmployee = (
  value,

  setEmployeeList,
  
) => {
  var axios = require("axios");
  
  const data = {
    searchText: value ? value : "",
  };
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1/searchText=${value}`,
    // url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1`,

    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // params: data,
  };

  axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1/${
      value ? value : "%20"
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(function (response) {
      setEmployeeList(response?.data);
    })
    .catch(function (error) {
      // setErrorMessage(error.response.data.message);
    });
};
const getOneEmployee = (
  value,

  setEmployeeRecorde
) => {
  var axios = require("axios");
  
  const data = {
    searchText: value ? value : "",
  };
  var config = {
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1/searchText=${value}`,
    // url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1`,

    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // params: data,
  };

  axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetEmployeeList_v1/${
      value ? value : "%20"
    }`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(function (response) {
      
      setEmployeeRecorde({
        employeeCode: response?.data[0].employeeCode,
        employeeName:response?.data[0].employeeName,
        position:response?.data[0].position

      })
    
    })
    .catch(function (error) {

      // setErrorMessage(error.response.data.message);
    });
};
const getInvoiceType = async (
  refKey,
  setInvoiceTypeList,


) => {
  const data = {
    refKey,
  };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Invoices/GetRefrenceDatList_v1`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    params: data,
  })
    .then(async (res) => {
      setInvoiceTypeList(res.data)
    })
    .catch((err) => {});
};
const getSignatories = async (
  refKey,
  setInvoiceTypeList,


) => {
  // const data = {
  //   refKey,
  // };
  await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/InvoiceDetails/referenceKeyLocationWise/${refKey}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    // params: data,
  })
    .then(async (res) => {
      setInvoiceTypeList(res.data)
    })
    .catch((err) => {});
};
const getVendorDetail = async (user, setUserData,setVendorCode, setLoading) => {
  setLoading(true);
  //
  await axios({
    method: "get", //you can set what request you want to be
    url: `${
      process.env.REACT_APP_API_URL
    }/api/InvoiceDetails/getVendorDetails/${user ? user : null}`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      setUserData(res.data);
      
      if(user){
        setVendorCode({
          Vendor_Code:res.data[0]?.Vendor_Code,
          Vendor_Name:res.data[0]?.Vendor_Name,
        })
      }
      setLoading(false);
    })
    .catch((err) => {
      setLoading(false);

      // setErrorMessage("Invalid username or password");
    });
};
export {
  getRefrenceDataList,
  
  AddRefrenceDataList,
  PutRefrenceDataList,
  deleteItem,
  getEmployee,
  getInvoiceType,
  getOneEmployee,
  getVendorDetail,
  getSignatories,
  getRefrenceDataListForOneRecord,

};
